export default __webpack_public_path__ + "static/media/talent_finder_export_inactive.58d6a5ac.svg";